/**
 * Открыть внутренний путь приложения в новой вкладке (тот же origin).
 *
 * @param {string} pathnameAndSearch — путь с query, например `/proxies?client_login=a&page=1`
 */
export const openAppPathInNewTab = (pathnameAndSearch) => {
  const raw = pathnameAndSearch.startsWith('/') ? pathnameAndSearch : `/${pathnameAndSearch}`;
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const url = `${base}${raw}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};
